export const FloatingAlign = {
  START: 'start',
  CENTER: 'center',
  END: 'end',
} as const;
export type FloatingAlign = (typeof FloatingAlign)[keyof typeof FloatingAlign];
